import groq from 'groq';

export const DATE_RANGE = groq`
  startDate,
  endDate,
  allDay,
  timezone
`;
